import type { Engine } from '@babylonjs/core/Engines/engine';
import type { RuntimeProfile } from './RuntimeProfile';

const SAMPLE_MS = 2500;
const LOW_FPS = 45;
const RECOVERY_FPS = 57;
const STEP = 0.25;

export interface AdaptiveQualityState {
  pixelRatio: number;
  minPixelRatio: number;
  maxPixelRatio: number;
  lowSamples: number;
  recoverySamples: number;
  lastFps: number;
}

export function installAdaptiveQuality(engine: Engine, profile: RuntimeProfile): AdaptiveQualityState {
  const state: AdaptiveQualityState = {
    pixelRatio: profile.pixelRatio,
    minPixelRatio: profile.minPixelRatio,
    maxPixelRatio: profile.pixelRatio,
    lowSamples: 0,
    recoverySamples: 0,
    lastFps: 0,
  };

  if (!profile.isMobile) return state;

  if (typeof window !== 'undefined') {
    (window as any).__eldrickAdaptiveQuality = state;
  }

  window.setInterval(() => {
    const fps = engine.getFps();
    if (!Number.isFinite(fps) || fps <= 0) return;
    state.lastFps = fps;

    if (fps < LOW_FPS && state.pixelRatio > state.minPixelRatio) {
      state.lowSamples++;
      state.recoverySamples = 0;
      if (state.lowSamples >= 2) {
        state.pixelRatio = Math.max(state.minPixelRatio, state.pixelRatio - STEP);
        engine.setHardwareScalingLevel(1 / state.pixelRatio);
        state.lowSamples = 0;
      }
      return;
    }

    if (fps > RECOVERY_FPS && state.pixelRatio < state.maxPixelRatio) {
      state.recoverySamples++;
      state.lowSamples = 0;
      if (state.recoverySamples >= 6) {
        state.pixelRatio = Math.min(state.maxPixelRatio, state.pixelRatio + STEP);
        engine.setHardwareScalingLevel(1 / state.pixelRatio);
        state.recoverySamples = 0;
      }
      return;
    }

    state.lowSamples = 0;
    state.recoverySamples = 0;
  }, SAMPLE_MS);

  return state;
}
